var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3043_14673)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.6 0C0.268629 0 0 0.268629 0 0.6C0 0.931371 0.268629 1.2 0.6 1.2H3.52059L4.31906 4.72891L5.90593 12.1525C6.26092 13.8132 7.72818 15 9.4264 15H14.9503C16.6611 15 18.1355 13.796 18.4776 12.1199L19.9878 4.71997C20.0238 4.54344 19.9786 4.36007 19.8647 4.22051C19.7507 4.08096 19.5801 3.99999 19.3999 3.99999H5.38446L4.58521 0.467589C4.52334 0.194146 4.28035 0 4 0H0.6ZM7.07942 11.9017L5.64687 5.19999H18.6651L17.3018 11.8799C17.0738 12.9974 16.0908 13.8 14.9503 13.8H9.4264C8.29425 13.8 7.31608 13.0088 7.07942 11.9017ZM17.3999 17.2C16.9581 17.2 16.5999 17.5582 16.5999 18C16.5999 18.4418 16.9581 18.8 17.3999 18.8C17.8417 18.8 18.1999 18.4418 18.1999 18C18.1999 17.5582 17.8417 17.2 17.3999 17.2ZM15.3999 18C15.3999 16.8954 16.2953 16 17.3999 16C18.5045 16 19.3999 16.8954 19.3999 18C19.3999 19.1046 18.5045 20 17.3999 20C16.2953 20 15.3999 19.1046 15.3999 18ZM7.3999 17.2C6.95807 17.2 6.5999 17.5582 6.5999 18C6.5999 18.4418 6.95807 18.8 7.3999 18.8C7.84173 18.8 8.1999 18.4418 8.1999 18C8.1999 17.5582 7.84173 17.2 7.3999 17.2ZM5.3999 18C5.3999 16.8954 6.29533 16 7.3999 16C8.50447 16 9.3999 16.8954 9.3999 18C9.3999 19.1046 8.50447 20 7.3999 20C6.29533 20 5.3999 19.1046 5.3999 18Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3043_14673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.fccfbc39a6d942df94bf482d10770447.svg";
export { ForwardRef as ReactComponent };